import { Image } from "antd";
import { checkStatusType, contitutionType, suggestionsType } from "../const";
import './Feedback.css';

export default function ConstitutionResult({
    removePTags,
    dataList,
    row,
    id
}: any) {

    const getExpandedData = () => {
        const foundItem: any = dataList?.find((item: any) => item?.id === id);
        return foundItem;
    }

    const getData: any = () => {
        const expandedData = getExpandedData();
        const master = expandedData?.resultData?.checkFinalResult?.master?.name || '';
        const slave = expandedData?.resultData?.checkFinalResult?.slave?.name || '';
        const constitutions = expandedData?.resultData?.parsingResult?.constitutions || [];
        const suggestions = expandedData?.resultData?.parsingResult?.suggestions || [];

        const masterConstitutions = constitutions.flat().find((item: any) => item.contentName === master);
        const slaveConstitutions = constitutions.flat().find((item: any) => item.contentName === slave);
        const masterSuggestions = suggestions.flat().find((item: any) => item.contentName === master);
        const slaveSuggestions = suggestions.flat().find((item: any) => item.contentName === slave);

        return {
            "master": master,
            "slave": slave,
            "masterConstitutions": masterConstitutions || [],
            "slaveConstitutions": slaveConstitutions || [],
            "masterSuggestions": masterSuggestions || [],
            "slaveSuggestions": slaveSuggestions || [],
        };
    };

    if (!getData().master) {
        const expandedData = getExpandedData();
        if (!expandedData) {
            return <div style={{ display: "flex", justifyContent: "space-around" }}>
                检测结果不存在或已被删除
            </div>
        }
        return <>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
                <div>检测状态：{checkStatusType[row?.status]?.text || row.status}</div>
                <div>检测图片：<Image width={50} height={50} src={expandedData?.imageUrl} /></div>
                <div>原因:{row.reason}</div>
            </div>
        </>
    }

    return (
        <div className="expandRow">
            <div style={{ width: '23%' }} className="diagnosisCard">
                <div className="title">主要体质为<span className="subtitle">{getData().master}</span></div>
                <div className="box-container">
                    <div className="tongue-content-wrapper">
                        {getData().masterConstitutions?.mediaList.map((item: any, index: number) => (
                            <div key={index} className="tongue-content" style={{ marginBottom: 10, display: 'flex' }}>
                                <span style={{
                                    letterSpacing: '1px', color: '#94724B', fontSize: 15, fontWeight: 500,
                                    minWidth: '70px', paddingRight: '10px', lineHeight: '24px'
                                }}>{contitutionType[item.fieldKey as keyof typeof contitutionType]?.text || '未知'}</span>
                                <span style={{ color: '#333333' }} dangerouslySetInnerHTML={{ __html: removePTags(item.description) }}></span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {
                getData().slave && <div style={{ width: '23%' }} className="diagnosisCard">
                    <div className="title">兼有体质为<span className="subtitle">{getData().slave}</span></div>
                    <div className="box-container">
                        <div className="tongue-content-wrapper">
                            {getData().slaveConstitutions?.mediaList.map((item: any, index: number) => (
                                <div key={index} className="tongue-content" style={{ marginBottom: 10, display: 'flex' }}>
                                    <span style={{
                                        letterSpacing: '1px', color: '#94724B', fontSize: 15, fontWeight: 500,
                                        minWidth: '70px', paddingRight: '10px', lineHeight: '24px'
                                    }}>{contitutionType[item.fieldKey as keyof typeof contitutionType]?.text || '未知'}</span>
                                    <span style={{ color: '#333333' }} dangerouslySetInnerHTML={{ __html: removePTags(item.description) }}></span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            }
            <div style={{ width: '23%' }} className="diagnosisCard">
                {getData().masterSuggestions?.mediaList.slice(0, 3).map((item: any, index: number) => (
                    <div key={index}>
                        <div className="title" style={{ marginTop: item.fieldKey === 'overall_suggestion' ? 0 : 30 }}>
                            {suggestionsType[item.fieldKey as keyof typeof suggestionsType]?.text || '未知'}
                        </div>
                        <div className="box-container" style={{ marginBottom: 10 }}>
                            <div className="tongue-content-wrapper">
                                <div key={index} className="tongue-content" style={{ marginBottom: 10 }}>
                                    <div className="tongue-title">{suggestionsType[item.fieldKey as keyof typeof suggestionsType]?.text || '未知'}</div>
                                    <div style={{ color: '#333333' }} dangerouslySetInnerHTML={{
                                        __html: removePTags(item.description)
                                            .replace(/<strong>(\d+[\.、])(.*?)<\/strong>/g, '<div style="display: block; color: #D8A66E; margin: 10px 0; ">$2</div>')
                                    }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div style={{ width: '23%' }} className="diagnosisCard">
                {getData().masterSuggestions?.mediaList.slice(3, 6).map((item: any, index: number) => (
                    <div key={index}>
                        <div className="title" style={{ marginTop: item.fieldKey === 'exercise_regulation' ? 0 : 30 }}>
                            {suggestionsType[item.fieldKey as keyof typeof suggestionsType]?.text || '未知'}
                        </div>
                        <div className="box-container" style={{ marginBottom: 10 }}>
                            <div className="tongue-content-wrapper">
                                <div key={index} className="tongue-content" style={{ marginBottom: 10 }}>
                                    <div className="tongue-title">{suggestionsType[item.fieldKey as keyof typeof suggestionsType]?.text || '未知'}</div>
                                    <div style={{ color: '#333333' }} dangerouslySetInnerHTML={{
                                        __html: removePTags(item.description)
                                            .replace(/<strong>(\d+[\.、])(.*?)<\/strong>/g, '<div style="display: block; color: #D8A66E; margin: 10px 0; ">$2</div>')
                                    }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}